
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import ChannelPage from '@/components/agents/channels-landing/ChannelPage';
import { useLineContent } from '@/components/agents/channels-landing/content/line';
export default function LineAgents() {
    const content = useLineContent();
    return <ChannelPage content={content}/>;
}

    async function __Next_Translate__getStaticProps__1a15d7d9a09__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chatbots/line',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15d7d9a09__ as getStaticProps }
  